<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import MultiSelect from "vue-multiselect";

// Custom Components
import PageHeader from "@/components/page-header";
import RFIDEncoderDrawer from "@/components/superAdmin/IOTLock/RFIDEncoder.vue";
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import Middlewares from "@/helpers/middlewares";
import appConfig from "@/app.config";

export default {
  page: {
    title: "RFID Encoder",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "List Of RFID ENCODER",
      isLoading: false,
      table: {
        tableData: [],
        size: 100,
        next: null,
        previous: null,
      },
      tableDataCopy: [],
      addRFIDEncoderModel: false,
      isEdit: false,
      rfidEncoderId: null,
      rfidEncoder: null,
      filters: {
        hotel: { text: "All", value: "all" },
        status: "all",
      },
      hotels: [],
      isChangeFilterValue: false,
      isApplyFilter: false,
    };
  },
  computed: {
    rfidEcoderProps() {
      return {
        rfidEncoderId: this.rfidEncoderId,
        isEdit: this.isEdit,
        rfidEncoder: this.rfidEncoder,
        hotelOptions: this.hotels,
      };
    },
  },
  components: {
    PageHeader,
    Drawer,
    RFIDEncoderDrawer,
    MultiSelect,
  },
  mounted() {
    this.getRFIDEncoderList(`?size=${this.table.size}`);
    this.getHotels();
  },
  methods: {
    // Method is used to get list of all hotels
    async getHotels() {
      if (localStorage.hotels) {
        this.hotels = JSON.parse(atob(localStorage.getItem("hotels")));
      } else {
        this.hotels = await Middleware.hotelList();
      }
    },
    // Method is used to get rfid Encoder list
    async getRFIDEncoderList(query) {
      this.isLoading = true;
      try {
        const response = await UserService.getRFIDEncoderList(query);
        if (response) {
          this.table.previous = response.previous;
          this.table.next = response.next;
          this.table.tableData = response.results;
          this.tableDataCopy = response.results;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle drawer
    addRFIDENcoderDrawer(isEdit) {
      if (typeof isEdit !== "boolean") {
        this.isEdit = false;
        this.rfidEncoderId = null;
        this.rfidEncoder = null;
      }
      this.addRFIDEncoderModel = !this.addRFIDEncoderModel;
    },
    // Method is use update and add new guest in guest list table
    handleSubmit({ data, isEdit }) {
      if (isEdit) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.table.tableData.push(data);
      }
      this.isEdit = false;
      this.rfidEncoderId = null;
      this.rfidEncoder = null;
      this.addRFIDENcoderDrawer();
      Middlewares.notification(
        `${isEdit ? "Updated successfully !!" : "Added successfully !!"}`,
        "success"
      );
    },
    // Method is used to edit rfid Encoder
    editRFIDEncoder(rfidEncoder) {
      this.isEdit = true;
      this.rfidEncoder = rfidEncoder;
      this.rfidEncoderId = rfidEncoder.id;
      this.addRFIDENcoderDrawer(this.isEdit);
    },
    // Method is used to change status
    changeStatus(rfid_encoder_id) {
      let RfidEncoderData = new FormData();
      RfidEncoderData.append("is_active", rfid_encoder_id.is_active);
      UserService.editRFIDEncoder(rfid_encoder_id.id, RfidEncoderData)
        .then((response) => {
          this.table.tableData.map((rfid_encoder, index) => {
            if (rfid_encoder.id == response.id) {
              this.$set(this.table.tableData, index, response);
            }
          });
          Middlewares.notification("Successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to change TLS status
    changeTLSStatus(rfid_encoder_id) {
      let RfidEncoderData = new FormData();
      RfidEncoderData.append(
        "is_tls_protocol",
        rfid_encoder_id.is_tls_protocol
      );
      UserService.editRFIDEncoder(rfid_encoder_id.id, RfidEncoderData)
        .then((response) => {
          this.table.tableData.map((rfid_encoder, index) => {
            if (rfid_encoder.id == response.id) {
              this.$set(this.table.tableData, index, response);
            }
          });
          Middlewares.notification("Successfully changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to delete device
    deleteRFIDEncoder(rfid_endcoder_id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteRFIDEncoder(rfid_endcoder_id)
            .then(() => {
              this.table.tableData = this.table.tableData.filter(
                (item) => item.id !== rfid_endcoder_id
              );
              Middlewares.notification("Successfully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to get more guest
    loadMore: function () {
      if (this.table.next !== null) {
        const str = this.table.next.split("?");
        this.getDevices(`?${str[1]}`);
      }
    },
    // Method is used to handle filter
    handleFilter() {
      this.isChangeFilterValue = true;
    },
    // Method is used to apply filter
    applyFilter() {
      if (this.isApplyFilter) {
        this.filters = {
          hotel: { text: "All", value: "all" },
          status: "all",
        };
        this.isApplyFilter = false;
        return this.getRFIDEncoderList("?size=" + this.table.size);
      }
      if (this.isChangeFilterValue) {
        this.isApplyFilter = true;
        let filter = "";
        if (this.filters.hotel.value !== "all") {
          filter += `?hotel=${this.filters.hotel.value}`;
        }
        if (this.filters.status !== "all") {
          if (filter == "") {
            filter += `?is_active=${this.filters.status}`;
          } else {
            filter += `&is_active=${this.filters.status}`;
          }
        }
        this.getRFIDEncoderList(filter);
      }
    },
    // Method is used to copy code
    copyCode(code) {
      Middleware.copyCode(code);
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      text="Add New"
      :isButton="true"
      :action="addRFIDENcoderDrawer"
    />
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="isLoading"
      infinite-scroll-distance="100"
    >
      <div class="card">
        <div class="card-body">
          <div class="row">
            <!-- Filter RFID Encoder by hotel -->
            <div class="col-xl-3 col-lg-5 col-md-6 col-sm-8">
              <MultiSelect
                class="mb-2"
                v-model="filters.hotel"
                :options="hotels"
                :show-labels="false"
                placeholder="Select Hotel"
                track-by="value"
                label="text"
                name="hotels"
                :allow-empty="false"
                @close="handleFilter()"
              />
            </div>
            <!-- Filter RFID Encoder by status -->
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-4">
              <select
                name="rfid_encoder_status"
                id="rfid_encoder_status"
                class="form-control mb-2"
                v-model="filters.status"
                placeholder="by is status"
                @change="handleFilter()"
              >
                <option value="all">All</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-2">
              <b-button
                variant="primary"
                active
                class="float-end float-md-start mb-2"
                @click="applyFilter"
                >{{
                  !isApplyFilter ? "Apply Filter" : "Clear Filter"
                }}</b-button
              >
            </div>
          </div>
          <div class="table-responsive">
            <v-table
              :data="table.tableData"
              class="table table-hover mb-0"
              ref="my-table"
            >
              <thead class="table-light" slot="head">
                <tr>
                  <th>Hotel</th>
                  <th>MQTT Device Id</th>
                  <th>MQTT Host</th>
                  <th>MQTT Port</th>
                  <th>COM Port</th>
                  <th>MQTT User</th>
                  <th>MQTT Password</th>
                  <th>TLS Protocol</th>
                  <th>Status</th>
                  <th>Activation Code</th>
                  <th>Created By</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody
                class="infinite-list"
                slot="body"
                slot-scope="{ displayData }"
                v-if="!isLoading && table.tableData.length !== 0"
              >
                <tr v-for="(RFIDEncoder, index) in displayData" :key="index">
                  <td @click="editRFIDEncoder(RFIDEncoder)">
                    {{
                      RFIDEncoder.hotel !== null ? RFIDEncoder.hotel.name : "-"
                    }}
                  </td>
                  <td @click="editRFIDEncoder(RFIDEncoder)">
                    {{ RFIDEncoder.mqtt_device_id }}
                  </td>
                  <td @click="editRFIDEncoder(RFIDEncoder)">
                    {{ RFIDEncoder.mqtt_host }}
                  </td>
                  <td>{{ RFIDEncoder.mqtt_port }}</td>
                  <td>{{ RFIDEncoder.com_port }}</td>
                  <td @click="editRFIDEncoder(RFIDEncoder)">
                    {{ RFIDEncoder.mqtt_user }}
                  </td>
                  <td
                    class="cursor"
                    v-b-popover.hover.bottom="'Copy'"
                    @click="copyCode(RFIDEncoder.mqtt_password)"
                  >
                    <div class="overflow-tip">
                      <span>{{ RFIDEncoder.mqtt_password }}</span>
                    </div>
                  </td>
                  <td>
                    <div
                      class="form-check form-switch my-1"
                      slot="is_tls_protocol"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="RFIDEncoder.is_tls_protocol"
                        @change="
                          changeTLSStatus({
                            id: RFIDEncoder.id,
                            is_tls_protocol: RFIDEncoder.is_tls_protocol,
                          })
                        "
                      />
                    </div>
                  </td>
                  <td>
                    <div class="form-check form-switch my-1" slot="is_active">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="RFIDEncoder.is_active"
                        @change="
                          changeStatus({
                            id: RFIDEncoder.id,
                            is_active: RFIDEncoder.is_active,
                          })
                        "
                      />
                    </div>
                  </td>
                  <td
                    class="cursor"
                    v-b-popover.hover.bottom="'Copy'"
                    @click="copyCode(RFIDEncoder.activation_code)"
                  >
                    <div class="overflow-tip">
                      <span>{{ RFIDEncoder.activation_code }}</span>
                    </div>
                  </td>
                  <td @click="editRFIDEncoder(RFIDEncoder)">
                    {{
                      RFIDEncoder.created_by !== null
                        ? RFIDEncoder.created_by
                        : "-"
                    }}
                  </td>
                  <td>
                    <i
                      class="fas fa-pencil-alt text-success mx-1"
                      v-b-popover.hover="'Edit record'"
                      id="edit"
                      @click="editRFIDEncoder(RFIDEncoder)"
                    ></i>
                    <i
                      class="mdi mdi-trash-can text-danger fs-5 mx-1"
                      v-b-popover.hover="'Delete record'"
                      @click="deleteRFIDEncoder(RFIDEncoder.id)"
                    ></i>
                  </td>
                </tr>
              </tbody>
              <tbody slot="body" v-else-if="isLoading">
                <tr v-for="item in 10" :key="item">
                  <td class="placeholder-glow" v-for="no in 12" :key="no">
                    <span class="placeholder w-100 placeholder-lg"></span>
                  </td>
                </tr>
              </tbody>
              <tbody slot="body" v-else>
                <tr>
                  <td colspan="9" class="text-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </div>
      </div>
    </div>
    <!--Add and update RFID Encoder drawer -->
    <Drawer
      @close="addRFIDENcoderDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="800"
    >
      <div v-if="addRFIDEncoderModel">
        <RFIDEncoderDrawer
          :currentProps="rfidEcoderProps"
          @submitted="handleSubmit"
          @cancelSubmit="addRFIDENcoderDrawer()"
        ></RFIDEncoderDrawer>
      </div>
    </Drawer>
  </div>
</template>
